import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    status: "not-authenticated", // 'authenticated', 'checking', 'loggingOut', 'not-authenticated'
    name: null,
    email: null,

    phoneNumber: null,
    identificator: null,
    roles: null,
    token: null,
    errorMessage: null,
  },
  reducers: {
    login: (state, { payload }) => {
      state.status = "authenticated"; // 'authenticated', 'checking', 'loggingOut', 'not-authenticated'
      state.name = payload.user.name;
      state.email = payload.user.email;
      state.phoneNumber = payload.user.phoneNumber;
      state.identificator = payload.user.identificator;
      state.roles = payload.user.roles;
      state.token = payload.token;
      state.errorMessage = null;
    },
    logout: (state, { payload }) => {
      state.status = "not-authenticated"; // 'authenticated', 'checking', 'loggingOut', 'not-authenticated'
      state.name = null;
      state.email = null;
      state.phoneNumber = null;
      state.identificator = null;
      state.roles = null;
      state.token = null;
      state.errorMessage = payload?.errorMessage || null;
    },
    checkingCredentials: (state) => {
      state.status = "checking";
    },
  },
});

export const { login, logout, checkingCredentials } = authSlice.actions;
